'use client';

import React, { Fragment, useEffect, useState } from 'react';
import { useQuery } from "@apollo/client";

import Header from '../../components/Header';
import Load from '../../components/Load';
import ProfileCardTournament from "../../components/ProfilecardTournament";


import {
  TORNEIO_POR_ID,
  TorneioPorIdData,
  TorneioPorIdVars,
} from "../../services/torneioService";
import { useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Createpost from '../../components/Createpost';
import PostRouter from '../../components/PostRouter';
import {
    listarPostsPorTorneio,
    Post,
} from '../../services/postService';

const Tournaments: React.FC = () => {
    
    const { id: torneioId } = useParams<{ id: string }>();
    if (!torneioId) {
        return (
            <div className="alert alert-danger" role="alert">
                Torneio não encontrado. 
            </div>
        );
    }
    
    const { data, loading, error } = useQuery<TorneioPorIdData, TorneioPorIdVars>(
        TORNEIO_POR_ID,
        {
            variables: { id: torneioId || "" },
            skip: !torneioId,
        },
    );
    const torneio = data?.torneioPorId;
    
     const user = useAuth()?.user || (typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user') || 'null') : null);
        const atletaId = user?.atleta?.id ?? '';
        const isAdmin = user?.role === 'ADMIN';
    
        const [posts, setPosts] = useState<Post[]>([]);
        const [page, setPage] = useState(0);
        const [postsLoading, setPostsLoading] = useState(false);
        const [postsError, setPostsError] = useState<string | null>(null);
        const [hasMore, setHasMore] = useState(true);
        const pageSize = 10;

        const loadPosts = async (pageToLoad: number, append = false) => {
            if (!torneioId) return;
            setPostsLoading(true);
            setPostsError(null);
            try {
                const result = await listarPostsPorTorneio(
                    torneioId,
                    pageToLoad,
                    pageSize,
                    atletaId,
                    torneioId
                );
                const items = result.items || [];
                setPosts((prev) => (append ? [...prev, ...items] : items));
                setHasMore(pageToLoad < (result.totalPages - 1));
            } catch (err) {
                setPostsError('Erro ao carregar posts.');
            } finally {
                setPostsLoading(false);
            }
        };

        useEffect(() => {
            loadPosts(0);
        }, [torneioId]);

        const handlePostCreated = async () => {
            setPage(0);
            await loadPosts(0);
        };

        const handleLoadMore = () => {
            const nextPage = page + 1;
            loadPosts(nextPage, true);
            setPage(nextPage);
        };
    
        
    return (
        <Fragment>
            <Header />

            <div className="main-content right-chat-active">
                <div className="middle-sidebar-bottom">
                    <div className="middle-sidebar-left pe-0">
                        <div className="row">
                            <div className="col-xl-12 col-xxl-12 col-lg-12">
                                {loading && <Load />}
                                {error && (
                                <div className="alert alert-danger" role="alert">
                                    Erro ao carregar torneio.
                                </div>
                                )}
                                {torneio && <ProfileCardTournament torneio={torneio} />}
                            </div>
                        </div>
                        <div className="row feed-body">
                            <div className="">
                                {/* <Storyslider /> */}
                                {isAdmin && torneio && (
                                    <Createpost autorTorneio={torneio} onPostCreated={handlePostCreated} />
                                )}
                                {postsLoading && <Load />}
                                {postsError && (
                                    <div className="alert alert-danger" role="alert">
                                        {postsError}
                                    </div>
                                )}
                                {!postsLoading && posts.length === 0 && (
                                    <div className="alert alert-info" role="alert">
                                        Nenhum post encontrado para este torneio.
                                    </div>
                                )}
                                {posts.map((post) => (
                                    <PostRouter
                                        key={post.id}
                                        post={post}
                                        torneioId={torneioId}
                                    />
                                ))}
                                {hasMore && posts.length > 0 && (
                                    <div className="text-center">
                                        <button className="btn btn-primary" onClick={handleLoadMore}>
                                            Carregar mais
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
        </Fragment>
    );
};

export default Tournaments;